var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 12.7 12.7",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M221.589 151.047a2.824 2.824 0 1 1 0-5.648 2.824 2.824 0 0 1 0 5.648m2.06-8.622h-4.12c-.797 0-1.533.425-1.93 1.115l-2.062 3.569a2.229 2.229 0 0 0 0 2.228l2.061 3.57a2.229 2.229 0 0 0 1.93 1.114h4.121a2.23 2.23 0 0 0 1.93-1.115l2.061-3.569c.398-.69.398-1.539 0-2.228l-2.06-3.57a2.229 2.229 0 0 0-1.93-1.114m-2.061 8.895a3.101 3.101 0 0 0 3.097-3.097 3.101 3.101 0 0 0-3.097-3.098 3.101 3.101 0 0 0-3.098 3.098 3.101 3.101 0 0 0 3.098 3.097m2.06-8.622a1.96 1.96 0 0 1 1.694.978l2.06 3.57a1.96 1.96 0 0 1 0 1.955l-2.06 3.569a1.96 1.96 0 0 1-1.694.977h-4.12a1.96 1.96 0 0 1-1.694-.977l-2.06-3.57a1.96 1.96 0 0 1 0-1.955l2.06-3.569a1.96 1.96 0 0 1 1.693-.978h4.121",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.182279
    },
    transform: "translate(-215.239 -141.87)"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settings_icon.20978dacadf3fe80f4e327d6a5a0cd57.svg";
export { ForwardRef as ReactComponent };